export default "__VITE_ASSET__C0I7TTY1__"